import React, { Fragment } from 'react';

import useLSCRoleEmails from './UseLSCRoleEmails';

import LSCRoleEmailsGrid from './LSCRoleEmailsGrid';

import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

const LSCRoleEmails = () => {
  const {
    isLoading,
    memberAdministrationLscRoleEmailsState,
    onAddRoleEmail,
    onEditRoleEmail,
    onDeleteRoleEmail
  } = useLSCRoleEmails();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>LSC Role Emails</Headings.H3>
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <ActionIntraPageButton type="button" onClick={onAddRoleEmail}>Add Role Email</ActionIntraPageButton>
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12">
          <LSCRoleEmailsGrid
            data={memberAdministrationLscRoleEmailsState.arrayData}
            isLoading={memberAdministrationLscRoleEmailsState.isArrayLoading}
            onEdit={onEditRoleEmail} 
            onDelete={onDeleteRoleEmail} />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default LSCRoleEmails;